import gql from "graphql-tag";

export const MUTATION_ADD_REPORT = gql`
  mutation addReport(
    $reportNumber: String!
    $name: String!
    $orderConfirmation: String!
    $shippingDate: DateTime!
    $customerOrderNumber: String!
    $products: [ProductInput!]!
    $customer: String
    $supplier: String
    $productionPlant: String
    $work_order_nr: String
    $orderDate: DateTime
  ) {
    addReport(
      reportNumber: $reportNumber
      name: $name
      orderConfirmation: $orderConfirmation
      customerOrderNumber: $customerOrderNumber
      shippingDate: $shippingDate
      products: $products
      customer: $customer
      supplier: $supplier
      productionPlant: $productionPlant
      work_order_nr: $work_order_nr
      orderDate: $orderDate
    )
  }
`;
